import { Component, Input, OnInit } from '@angular/core';
import { CompanyData, ContractorData, ObservationData } from 'src/app/performance-dashboard/model/performance.model';
import { Router } from '@angular/router';
import { PerformanceService } from '../../../services/performance.service';
import { ConstantsService } from '../../../../shared/services/constants.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'ara-safety-observation',
  templateUrl: './safety-observation.component.html',
  styleUrls: ['./safety-observation.component.css']
})
export class SafetyObservationComponent implements OnInit {
  @Input() safetyObsData;
  @Input() selectedUnit: any;
  @Input() year: any;
  @Input() MonthRange: any;
  clonedContractorData: { [s: string]: ContractorData } = {};
  clonedCompanyData: { [s: string]: CompanyData } = {};
  contractorData: ContractorData[];
  companyData: CompanyData[];
  clonedObs: { [s: string]: ObservationData } = {};
  SafObsData : any;
  DisableExport : boolean = false;
  constructor(private PDService: PerformanceService,private router: Router) { }

  ngOnInit(): void {

  }


  onRowEditInit(Obs: ObservationData) {
    this.clonedObs[Obs.Id] = { ...Obs };
    this.DisableExport = true;
  }

  onRowEditSave(Obs: ObservationData, index: number) {
    if (Obs.Id > 0) {
      delete this.clonedObs[Obs.Id];
      this.safetyObsData[index].Total = Obs.Jan + Obs.Feb + Obs.Mar + Obs.Apr + Obs.May + Obs.Jun + Obs.Jul + Obs.Aug + Obs.Sep + Obs.Oct + Obs.Nov + Obs.Dec;
    }
    this.DisableExport = Object.keys(this.clonedObs).length > 0 ? true : false;
  }

  onRowEditCancel(Obs: ObservationData, index: number) {
    this.safetyObsData[index] = this.clonedObs[Obs.Id];
    delete this.clonedObs[Obs.Id];
    this.DisableExport = Object.keys(this.clonedObs).length > 0 ? true : false;
  }

  GetSafetyObservationSelectedDetails(UnitId,Unit,Column){
  
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,//this.child1.selectedUnit,
        "Year": this.year,//this.child1.year,
        "Months":this.MonthRange,//this.child1.MonthRange,
        "ModuleName":"Safety Observation",
        "Component":Unit === "Total" ? 0 : UnitId,
        "Column":Column,
        "ComponentName":Unit
     }
    };

    this.PDService.getPDSelectedDetails(apiRequest,this.callbackMethodForGetSafetyObservationSelectedDetails.bind(this));
  }
  callbackMethodForGetSafetyObservationSelectedDetails(response){
    if(response.Success)
    this.SafObsData = response.Result;
  }

  Redirect(value,UnitId)
  {
  //this.router.navigate(['/observation/make-observation/', value, { unitId:UnitId }])
  window.open(ConstantsService.URL.APP + ['/observation/make-observation/'+value+';unitId='+UnitId], '_self');
  }

  //BOC Pritesh
  exportToExcel()
  {

  let element = document.getElementById('ObservationTableToExport');
  const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
  ws['!ref'] = ws['!ref'].replace('O','N');//to remove Actions Column
  /* generate workbook and add the worksheet */
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  /* save to file */  
  XLSX.writeFile(wb, "Observation.xlsx");

  }
  //EOC Pritesh

}
